import React from "react";

export default function CamperSolarBlogDe() {
  return (
    <>
      <p>
        In der Winterpause habe ich mich damit beschäftigt, wie ich meinen Camper um ein Solarpanel erweitern kann.
        Dazu hatte ich mir in mehreren Schritten Gedanken gemacht und es tatsächlich dann auch installiert.
        Dokumentiert ist das Ganze auch in vier YouTube-Videos, die oben verlinkt sind. Aber nun zu den Schritten
        (die Details findet ihr in den YouTube-Videos).
      </p>

      

      <div className="blog-note">
        <em>
          <strong>Wichtig!</strong> Dieser Blog zeigt elektrische Schaltungen. Die Grundlagen dazu sowie die
          Schaltungen wurden zwar sorgfältig geprüft, ich kann aber dennoch keine Garantie für die Richtigkeit –
          insbesondere auf die Einhaltung sämtlicher Vorschriften – übernehmen. Zudem sollte bei der Arbeit mit
          elektrischen Systemen aufgrund der Gefahr für die Gesundheit und das Leben immer ein Fachmann hinzugezogen
          werden.
        </em>
      </div>

      <p><strong>Das Panel</strong></p>
      <p>
        Zunächst habe ich mir die Frage gestellt, wie viel brauche ich denn, und passt das aufs Dach. Nach dem
        Studium zahlreicher Videos und Blogs habe ich mir errechnet, wie viel Leistung ich brauche — also für Licht,
        Handy laden, auch mal den Laptop betreiben, die Wasserpumpe, die Steuerung von Heizung und Kühlschrank …
        ja alles recht wenig – ah, der Fön – ja der braucht viel … und 230 V. Alles in allem sollte ich aber mit
        120 Wp bis 180 Wp für das Panel auskommen. Je nachdem wie viel man für das Panel ausgeben möchte, passt das
        dann auch aufs Dach – denn je kompakter das Panel ist, desto teurer wird es auch. Während man für das
        Hausdach 400 Wp schon für 50 EUR kaufen kann, waren es bei mir für 175 Wp schon 350 EUR.
      </p>
      <p>
        Wo ist denn da eigentlich der Unterschied? Zum einen in der Größe – ein Modul für das Hausdach würde bei
        mir nicht auf den Camper passen. Zudem muss man bedenken, dass auf dem Camper wesentlich mehr Schwingungen
        auftreten als auf dem Hausdach und ein Haarriss das Panel zerstören könnte – und je größer, desto freier
        kann es schwingen. Dazu kommt noch, dass man beim Camper gerne etwas mehr Reserve beim Spannungsbereich hat –
        das hilft dann in der Dämmerung noch ein paar Watt zu erzeugen. Ich habe ein spezielles Hochvolt-Panel
        genommen. Dann wären da noch die Bypass-Dioden: ein Modul fürs Hausdach hat davon in der Regel eine, mein
        Panel besitzt drei und ist somit bei Teilverschattung noch in der Lage etwas Strom zu erzeugen. Zuletzt
        sind es die Volumina, in denen die Panels produziert werden – Panels für das Hausdach sind echte Massenware,
        das drückt den Preis.
      </p>

      <p><strong>Der Solar-Laderegler</strong></p>
      <p>
        Dazu braucht es einen Solar-Laderegler, der die Aufbaubatterie lädt, wenn die Sonne scheint. Er wandelt den
        Strom vom Dach in Ladestrom um und erkennt auch, wenn die Batterie voll ist. Er muss vom Spannungs- und
        Strombereich zum Panel passen. Bei mir sollte dann auch Bluetooth dazu vorhanden sein, um die Werte zu
        überwachen.
      </p>

      <p><strong>Die Batterie</strong></p>
      <p>
        Dazu sollte es dann schon eine 150 Ah Batterie sein – also 1.800 Wh – und es sollte eine
        Lithium-Eisen-Phosphat-Batterie (LiFePO4) sein. Die hat den Vorteil, dass sie leichter ist, eine höhere
        Kapazität als Blei-Akkus besitzt und diese auch effizienter nutzen kann. Und damit ich den Ladezustand gut
        ablesen kann, sollte sie auch Bluetooth können.
      </p>

      <p><strong>Der Wechselrichter</strong></p>
      <p>
        Für den Fön kam dann noch ein Wechselrichter mit 1.500 W dazu – so viel braucht der Fön mindestens. Der
        hat den Aufwand nochmal deutlich erhöht, weil – sofern man die normalen Bord-Steckdosen damit versorgen
        will – eine Netzvorrangschaltung noch obligatorisch ist. Ansonsten kollidiert der Solarstrom mit dem
        Landstrom.
      </p>

      <img
        src="/images/Camper-Solar-Schaltung.png"
        alt="Schaltplan der Solar-Installation im Camper"
        className="blog-img"
      />

      <p>
        Das Kabel zum Panel habe ich durch die Dachluke geführt (Midi-Heki) – ich wollte das Dach nicht
        durchbohren. Von dort ging es versteckt hinter der Verkleidung zum Stromkasten. Je nachdem wo das beim
        Camper liegt, ist das mehr oder weniger aufwändig. Ich habe ca. 5 m Kabel benötigt.
      </p>

      <p><strong>Die Kabel</strong></p>
      <p>
        Für jede Stromart braucht man einen eigenen Kabeltyp. Solarkabel für die Verbindung zum Panel aufs Dach –
        UV-stabil und dick isoliert (auf dem Hausdach hat man oft hohe Spannungen &gt; 800 V, hier im Camper sind
        es nur 60 V). Für die Verbindung vom Solar-Laderegler zur Batterie Standard-FLRY-B-Kfz-Kabel – in meinem
        Fall 4 mm², zum Wechselrichter dickes FLY 25 mm² Batteriekabel – möglichst kurz – und hinter dem
        Wechselrichter 1,5 mm² Starkstromkabel als Litze.
      </p>

      <p><strong>Das Monitor-Display</strong></p>
      <p>
        Nachdem alles installiert war, habe ich mir noch ein Display gebaut, mit dem ich die Batterien und den
        Solar-Laderegler überwachen kann. Das findet ihr inklusive einer Live-Demo ebenfalls auf dieser Seite.
      </p>
    </>
  );
}
